(() => {
  const normalize = (str) =>
    (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  function getInitialVariantFromSection(productInfoEl) {
    const script = productInfoEl?.querySelector('variant-selects script[data-selected-variant]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function togglePersonalizacao(wrapper, variant) {
    if (!wrapper) return;

    const nomeInput = wrapper.querySelector('input[name="properties[Name]"]');
    const numeroInput = wrapper.querySelector('input[name="properties[Number]"]');

    const options = Array.isArray(variant?.options) ? variant.options : [];
    const hasPersonalizar = options.some((opt) => /^(personalizar|com personalizacao|with personalization|with customization|personalized|customize|con personalizacion|con personalizzazione|avec personnalisation|personnaliser)$/.test(normalize(opt)));

    if (hasPersonalizar) {
      wrapper.classList.remove("hidden");
      if (nomeInput) nomeInput.disabled = false;
      if (numeroInput) numeroInput.disabled = false;
    } else {
      wrapper.classList.add("hidden");
      if (nomeInput) {
        nomeInput.value = "";
        nomeInput.disabled = true;
      }
      if (numeroInput) {
        numeroInput.value = "";
        numeroInput.disabled = true;
      }
    }
  }

  function initPersonalizacaoForProductInfo(productInfoEl) {
    const sectionId = productInfoEl?.dataset?.section;
    if (!sectionId) return;

    // wrapper que vamos adicionar no buy-buttons
    const wrapper = productInfoEl.querySelector(`[data-personalizacao-wrapper][data-section-id="${sectionId}"]`);
    if (!wrapper) return;

    // 1) estado inicial
    const initialVariant = getInitialVariantFromSection(productInfoEl);
    togglePersonalizacao(wrapper, initialVariant);

    // 2) quando mudar variante (evento nativo do Dawn)
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event?.data;
        if (!data || data.sectionId !== sectionId) return;
        togglePersonalizacao(wrapper, data.variant);
      });
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("product-info").forEach(initPersonalizacaoForProductInfo);
  });
})();
